import React from "react"

import PropTypes from "prop-types"

import "./validationRules.scss"

const ValidationRules = ({alignItems = "flex-end", rules}) => (
    <div className="validation-rules" style={{alignItems}}>
        {rules.map((rule, key) => (
            <p key={`${rule}-${key}`}>{rule}</p>
        ))}
    </div>
)

ValidationRules.propTypes = {
    alignItems: PropTypes.oneOf(["flex-start", "flex-end"]),
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ValidationRules
